import { createContext } from 'react';
import { Container } from 'inversify';

export interface IInjectionContext {
  container: Container;
}

export const InjectionContext = createContext<IInjectionContext>({} as IInjectionContext);
